import React from "react";
import { Mutation } from "react-apollo";
import _ from "lodash";
import { Form, Button, Modal, List, Icon, message } from "antd";
import { fieldTypes } from "../../Utils";
import {
  TextField,
  TextArea,
  NumberField,
  PasswordField,
  SelectField,
  MultiSelectField,
  SwitchField,
  FileField,
  CertificateForm
} from "../../Modules/FormFields";
import validateFields from "./validations";
import { getOptions, parseValues } from "../../Utils/catalogues";

import SaveOrderField from "../../GraphQL/Mutation/SaveOrderField";
import GetOrder from "../../GraphQL/Query/GetOrder";
// import CreateOrderPartner from "../../GraphQL/Mutation/CreateOrderPartner";

class StepsForm extends React.Component {
  state = {
    errors: {},
    formValues: {},
    disabledSubmit: true,
    modalVisible: false,
    loading: false
  };

  componentDidMount() {
    const { parsedValues, orderId, orderStatus, user, mutate } = this.props;
    this.setState({ formValues: parsedValues });

    if (orderStatus === "created") {
      mutate({
        variables: {
          orderId,
          newStatus: "collectingData",
          userId: user.username
        },
        refetchQueries: [
          { query: GetOrder, variables: { orderId, userId: user.username } }
        ],
        update: (proxy, { data: { updateOrderStatus } }) => {
          const query = GetOrder;
          const variables = { orderId, userId: user.username };
          const data = proxy.readQuery({
            query,
            variables
          });

          proxy.writeQuery({ query, data });
        }
      });
    }
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    });
  };

  handleOk = () => {
    const { orderId, user, mutate } = this.props;
    this.setState({ loading: true });
    // AS_Partner "production"
    // const partnerAssigned = "us-east-1:4269647a-993f-453e-b7fa-6a6406ccd7aa";
    // demo_partner "development"
    // const partnerAssigned = "us-east-1:c9f1d88b-0be4-411d-90bb-20c6acf4e777";

    mutate({
      variables: {
        orderId,
        newStatus: "validatingData",
        userId: user.username
      },
      refetchQueries: [
        { query: GetOrder, variables: { orderId, userId: user.username } }
      ],
      update: (proxy, { data: { updateOrderStatus } }) => {
        const query = GetOrder;
        const variables = { orderId, userId: user.username };
        const data = proxy.readQuery({
          query,
          variables
        });

        proxy.writeQuery({ query, data });
      }
    }).catch(err => {
      // this.setState({ loading: false });
      message.error("Error al enviar tus datos!");
    });

    message.success("Datos enviados correctamente!");
    // copMutate({
    //   variables: { orderId, userId: partnerAssigned, consumerId: user.username }
    // })
    //   .then(() => message.success("Asignado correctamente"))
    //   .catch(err => message.error(err));
  };

  handleCancel = () => {
    this.setState({ modalVisible: false });
  };

  handleBlur(formValues, fieldName, mutate) {
    const { orderId, formFields, serviceId, user } = this.props;
    const field = { [fieldName]: formValues[fieldName] };
    const {
      id,
      type,
      label,
      placeholder,
      description,
      validation,
      required,
      value,
      step,
      order,
      file
    } = formFields[_.findIndex(formFields, ["fieldName", fieldName])];
    // console.log(field);
    if (
      _.isArray(formValues[fieldName]) ||
      _.isBoolean(formValues[fieldName]) ||
      !_.isEmpty(formValues[fieldName])
    ) {
      mutate({
        variables: { orderId, field: JSON.stringify(field) },
        optimisticResponse: {
          saveOrderFields: {
            __typename: "OrderField",
            id,
            serviceId,
            fieldName,
            type,
            label,
            placeholder,
            description,
            validation,
            required,
            value,
            step,
            order,
            file
          }
        },
        update: (proxy, { data: { saveOrderFields } }) => {
          const query = GetOrder;
          const data = proxy.readQuery({
            query,
            variables: { orderId, userId: user.username }
          });
          const { fieldName } = saveOrderFields;
          data.getOrder.fields[
            _.findIndex(data.getOrder.fields, ["fieldName", fieldName])
          ] = saveOrderFields;
          proxy.writeQuery({ query, data });
        }
      });
    }
  }

  handleOnChange = e => {
    const { formFields, currentStep } = this.props;
    const { errors, formValues } = this.state;
    const field = e.target.name;
    const value = e.target.value;
    const fieldValue = field === "rfc" ? value.trim().toUpperCase() : value;

    // console.log(field, value);

    _.assign(formValues, { [field]: fieldValue });
    const disabledSubmit = validateFields(
      field,
      fieldValue,
      errors,
      formValues,
      formFields,
      currentStep
    );
    this.setState({ disabledSubmit });
  };

  handleOnChangeSelect = (field, value) => {
    const { formFields, currentStep } = this.props;
    const { errors, formValues } = this.state;
    _.assign(formValues, { [field]: value });
    const disabledSubmit = validateFields(
      field,
      value,
      errors,
      formValues,
      formFields,
      currentStep
    );
    this.setState({ disabledSubmit });
  };

  renderField = field => {
    const { formValues, errors } = this.state;
    if (!_.includes(fieldTypes, field.type)) {
      return;
    }

    if (
      _.includes(
        ["employees", "payrollStamp", "employeesSocialSec"],
        field.fieldName
      )
    ) {
      if (!formValues["payrollPayment"]) {
        return;
      }
    }

    if (_.includes(["importersList"], field.fieldName)) {
      if (!formValues["importExport"]) {
        return;
      }
    }

    return (
      <Mutation mutation={SaveOrderField} key={field.id}>
        {mutate => {
          switch (field.type) {
            case "text":
              return (
                <TextField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  label={field.label}
                  description={field.description}
                  onChange={this.handleOnChange}
                  required={field.required}
                  errors={errors}
                  onBlur={() =>
                    errors[field.fieldName]
                      ? null
                      : this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            case "number":
              return (
                <NumberField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  label={field.label}
                  onChange={this.handleOnChangeSelect}
                  required={field.required}
                  errors={errors}
                  onBlurA={() =>
                    errors[field.fieldName]
                      ? null
                      : this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            case "password":
              return (
                <PasswordField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  label={field.label}
                  description={field.description}
                  onChange={this.handleOnChange}
                  required={field.required}
                  errors={errors}
                  onBlur={() =>
                    errors[field.fieldName]
                      ? null
                      : this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            case "textarea":
              return (
                <TextArea
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  label={field.label}
                  onChange={this.handleOnChange}
                  required={field.required}
                  errors={errors}
                  onBlur={() =>
                    errors[field.fieldName]
                      ? null
                      : this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            case "select":
              return (
                <SelectField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  placeholder={field.label}
                  label={field.label}
                  onChange={value => {
                    this.handleOnChangeSelect(field.fieldName, value);
                  }}
                  required={field.required}
                  errors={errors}
                  options={getOptions(field.fieldName)}
                  onBlur={() =>
                    this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            case "multiselect":
              return (
                <MultiSelectField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  placeholder={field.label}
                  label={field.label}
                  onChange={value => {
                    this.handleOnChangeSelect(field.fieldName, value);
                  }}
                  required={field.required}
                  errors={errors}
                  options={getOptions(field.fieldName)}
                  onBlur={() =>
                    this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            case "switch":
              return (
                <SwitchField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  label={field.label}
                  onChange={value => {
                    this.handleOnChangeSelect(field.fieldName, value);
                    this.handleBlur(formValues, field.fieldName, mutate);
                  }}
                  required={field.required}
                  errors={errors}
                />
              );
            case "file":
            case "multifile":
              return (
                <FileField
                  name={field.fieldName}
                  value={formValues[field.fieldName]}
                  multiple={field.type === "multifile"}
                  user={this.props.user}
                  label={field.label}
                  description={field.description}
                  onChange={value => {
                    this.handleOnChangeSelect(field.fieldName, value);
                    this.handleBlur(formValues, field.fieldName, mutate);
                  }}
                  required={field.required}
                  errors={errors}
                  downloadFile={field.file}
                />
              );
            case "certificate":
              return (
                <CertificateForm
                  {...field}
                  user={this.props.user}
                  serialValue={formValues[field.fieldName]}
                  rfc={formValues["rfc"]}
                  handleUpload={this.handleOnChangeSelect}
                  handleUpdate={() =>
                    this.handleBlur(formValues, field.fieldName, mutate)
                  }
                />
              );
            default:
              break;
          }
        }}
      </Mutation>
    );
  };

  nextStepDisabled = currStepFields => {
    const { formValues } = this.state;
    const currStepFieldsHasValues = [];
    _.map(_.filter(currStepFields, "required"), item => {
      currStepFieldsHasValues.push(
        !!(formValues[item.fieldName] && formValues[item.fieldName].length)
      );
    });
    return !_.every(currStepFieldsHasValues, Boolean);
  };

  renderList = item => {
    const { formValues } = this.state;
    if (item.type === "file") {
      return (
        (formValues[item.fieldName] && formValues[item.fieldName].key) ||
        "No se agregó archivo."
      );
    } else if (item.type === "multifile") {
      if (formValues[item.fieldName] && formValues[item.fieldName].length) {
        return (
          <ul>
            {_.map(formValues[item.fieldName], item => (
              <li key={item.key}>{item.key}</li>
            ))}
          </ul>
        );
      }
      return "No se agregaron archivos.";
    } else if (item.type === "switch") {
      return formValues[item.fieldName] ? "Sí" : "No";
    } else if (item.type === "password") {
      return "********";
    }

    return parseValues(item.fieldName, formValues[item.fieldName]);
  };

  render() {
    const {
      formFields,
      formSteps,
      currentStep,
      next,
      prev,
      setStep
    } = this.props;
    const { errors, modalVisible, loading } = this.state;
    // const currStepFields = _.filter(formFields, ["step", currentStep + 1]);
    const currStepFields = _.filter(formFields, [
      "step",
      formSteps[currentStep].step
    ]);
    const currStepHasErrors = !_.isEmpty(
      _.pick(errors, _.map(currStepFields, item => item.name))
    );
    // console.log(currStepFields, formFields, currStepHasErrors);
    return (
      <Form layout="vertical">
        <div className="steps-content">
          {currStepFields && currStepFields.length
            ? _.map(
                _.orderBy(currStepFields, ["step", "order"], ["asc", "asc"]),
                item => <div key={item.id}>{this.renderField(item)}</div>
              )
            : "No hay campos para este paso, continua con el siguiente paso o persiona el botón de terminado."}
        </div>
        <div className="steps-action">
          {currentStep > 0 && <Button onClick={prev}>Anterior</Button>}
          {currentStep < formSteps.length - 1 && (
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={next}
              disabled={
                this.nextStepDisabled(currStepFields) || currStepHasErrors
              }
            >
              Siguiente
            </Button>
          )}
          {currentStep === formSteps.length - 1 && (
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={this.showModal}
              // disabled={disabledSubmit || currStepHasErrors}
              disabled={
                this.nextStepDisabled(currStepFields) || currStepHasErrors
              }
            >
              Terminado
            </Button>
          )}
        </div>
        <Modal
          wrapClassName="vertical-center-modal"
          visible={modalVisible}
          title="Verificar datos ingresados"
          onOk={() => this.handleOk()}
          onCancel={this.handleCancel}
          bodyStyle={{ height: 600, overflow: "auto" }}
          width={800}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              Regresar
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={() => this.handleOk()}
            >
              Confirmar
            </Button>
          ]}
        >
          <List
            itemLayout="horizontal"
            dataSource={_.orderBy(
              formFields,
              ["step", "order"],
              ["asc", "asc"]
            )}
            renderItem={item => (
              <List.Item
                actions={[
                  <Icon
                    type="edit"
                    style={{ fontSize: 16, color: "#08c" }}
                    onClick={() => {
                      this.handleCancel();
                      setStep(item.step);
                    }}
                  />
                ]}
              >
                <List.Item.Meta
                  title={item.label}
                  description={this.renderList(item)}
                />
              </List.Item>
            )}
          />
        </Modal>
      </Form>
    );
  }
}

export default StepsForm;



// WEBPACK FOOTER //
// ./src/Components/Services/StepsForm.js